import { render, staticRenderFns } from "./AtendimentoDialog.vue?vue&type=template&id=469d2887&scoped=true"
import script from "./AtendimentoDialog.vue?vue&type=script&lang=js"
export * from "./AtendimentoDialog.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoDialog.vue?vue&type=style&index=0&id=469d2887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d2887",
  null
  
)

export default component.exports